import { BaseApi } from '@/core/api/base.api'
import { Room } from '@/core/api/room.api'
import { roomCallService } from '@/core/service/room.call.service'
import { roomUserService } from '@/core/service/room.user.service'
import { GrmWebRTC } from '@/lib/gooroomee/webrtc/GrmWebRTC'
import {} from '@/lib/gooroomee/webrtc/GrmWebRTC.getStats-1.0'
import _ from "lodash";

class RoomCallApi extends BaseApi {
  #Events = {}
  #timer = {}

  static webinarType={
    none: 'none',
    live: 'live',
    wall: 'wall',
  };

  constructor() {
    super()
    Room.Call = this

    this.#Events = {
      default: this._Events
    }

    let setEvent = () => {
      let callback = e => {
        let callType = Room.getRoomData().roomCall.callType

        const defaultListener = this.#Events['default'][e.type];
        if(defaultListener){
          defaultListener.call(this, e);
        }

        const run = (callType, e) => {
          let callTypeListener = this.#Events[callType] && this.#Events[callType][e.type];
          if(callTypeListener){
            callTypeListener.call(this, e)
          }
        }

        if(e.type === 'room_call_changeCallType'){
          const types = [e.data.beforeCallType, e.data.settings?.callType];
          types.forEach(callType => {
            run(callType, e);
          });
        }else{
          run(callType, e);
        }
      }

      let events = {}
      for (let type in this._Events) {
        events[type] = callback
      }
      this._eventListen(events)
    }

    Room.addEventListeners(this._CoreEvents, this);

    Room.ready(async e => {
      setEvent()

      let { data } = await roomCallService.getRoomCallInfo()
      Room.addRoomData({ roomCall: data })

      await Room.trigger('room_core_call_infoLoaded');
      // await this._enterCall();
    })
  }

  addCallTypeEventListener(callType, eventObj, instance) {
    function bind(listener, instance){
      if(!instance){
        return listener;
      }

      const func = function(){
        listener.apply(instance, arguments);
      }
      func.apply = function(instance, args){
        listener.apply(instance, args);
      }
      return func;
    }

    if (instance) {
      for (let type in eventObj) {
        eventObj[type] = bind(eventObj[type], instance) // eventObj[type].bind(instance)
        if(!this.#Events['default'][type]){
          this.#Events['default'][type] = function(e){}
        }
      }
    }
    this.#Events[callType] = Object.assign(
      {},
      this.#Events['default'],
      this.#Events[callType] || {},
      eventObj
    )
    return this
  }

  async changeCallType(params) {
    this._changeCallType_work = this._changeCallType_work || _.throttle(async (params) => {
      await roomCallService.changeCallType(params);
    }, 1000, {
      leading: true
    });
    this._changeCallType_work(params);
  }

  async changeVideoQuality(videoQuality) {
    await roomCallService.changeVideoQuality(videoQuality);
  }

  async changeWebinarType(webinarType) {
    await roomCallService.changeWebinarType(webinarType);
  }
  
  getWebinarType() {
    return Room.getRoomData().roomCall.webinarType || RoomCallApi.webinarType.none
  }

  setWebinarType(webinarType = RoomCallApi.webinarType.none) {
    return Room.getRoomData().roomCall.webinarType = webinarType
  }

  isWebinar(webinarType) {
    return this.getWebinarType() !== RoomCallApi.webinarType.none
        && (!webinarType || this.getWebinarType() === webinarType)
  }

  isWebinarLive() {
    return this.getWebinarType() === RoomCallApi.webinarType.live
  }

  isWebinarWall() {
    return this.getWebinarType() === RoomCallApi.webinarType.wall
  }

  getScreenShareUser() {
    const roomUser = Room.User.getRoomUserList().find(ru => {
      return ru.screenStatus
    });
    return roomUser;
  }

  async startScreenShare(constraints={}, callback) {
    let data = {sourceType: ['screen', 'window']};
    // 추후 오디로 필요 시
    let audioEnabled = false;
    if (audioEnabled) data.sourceType.push('audio');

    data.constraints = {
      video: {
        mandatory: {
          frameRate: constraints.frameRate || 10,
          width: 1280,
          height: 720,
        }
      }
    }

    const {stream} = await GrmWebRTC.getStreamId(data)

    if(!stream || stream.getTracks().length === 0){
      console.error('stream is empty :', data, stream);
      return;
    }

    let roomData = Room.getRoomData();
    const userId = Room.Call.getScreenShareUser()?.userId;

    roomData.me.screenStatus = true;
    if(!roomData.me.roomUserRole.screen){
      return GrmWebRTC.stopMediaStream(stream);
    }
    const {oriStream, screenStream} = await this.Stream.setCurrentScreenStream({
      stream, 
      options: {
        muted: !this.isWebinarWall()
      }
    });
    
    await Room.trigger('room_core_call_startScreenShare', {
      screenStream,
      callback: async () => {
      
        roomCallService.startScreenShare({
          streamId: screenStream.id,
          videoTrackId: screenStream.getVideoTracks()[0].id,
          channelIndex: 0,
          stopScreenShareUserId: userId,
        }).catch(e => console.error(e));

        Room.trigger('room_call_loadScreenShareStream');
        callback(oriStream);
      }
    });
  }

  async stopScreenShare({publish, userId}) {
    // this.Stream.removeScreenStream();

    await Room.trigger('room_core_call_stopScreenShare', {
          targetUserId: userId,
          screenShare: false,
      });
    if(publish !== false)
      await roomCallService.stopScreenShare({userId});
  }

  _Events = { // 여기에는 있지만 mixer, p2p 쪽에 없을 경우, 해당 event 중복 호출됨
    // room_reconnected: function(e) {},
    room_call_changeCallType: async function(e) {
      const settings = e.data.settings;
      const {callType, layoutType} = settings;

      const roomCall = Room.getRoomData().roomCall;
      if(roomCall.callType === callType){
        return;
      }
      roomCall.callType = callType;
      roomCall.videoLayout = layoutType;

      try{
        await this.Stream.removeCurrentLocalStream();
      }catch(e){
        console.warn(e);
      }

      Room.emit(e);
    },
    // room_user_enter: function(e) {
    // },
    room_leaved: function(e){
      this.Stream.destroy();
    },
    room_user_leave: function(e) {
      if(Room.User.isMe(e.data.userId)){
        this.Stream.destroy();
      }
    },
    // room_call_offer: function(e) {},
    // room_call_answer: function(e) {},
    // room_call_icecandidate: function(e) {},
    // room_call_signalStable: function(e) {},
    room_call_screenShare: function (e) {
      const {userId, data: {screenShare, targetUserId}} = e;
      const roomUser = Room.User.getRoomUser(userId);
           
      if(roomUser){
        if(screenShare === false){
          this.stopScreenShare({
            publish: false, 
            userId: targetUserId
          });
        }
        roomUser.screenStatus = screenShare;
      }
    },
    room_changeRoomMode: function (e) {
      const room = Room.getRoomData().room;

      const {prevRoomMode, roomMode} = room;

      if(prevRoomMode === 'screenShare'
        && prevRoomMode !== roomMode){
          Room.User.getRoomUserList().forEach(ru => {
            if(ru.screenStatus){
              ru.screenStatus = false;
              this.stopScreenShare({
                publish: false,
                userId: ru.userId
              });
            }
          })
      }     
    },
    room_call_changeVideoQuality: function (e) {
      const videoQuality = e.data.videoQuality;
      const roomCall = Room.getRoomData().roomCall;
      roomCall.videoQuality = videoQuality;

      Room.emit(e)
    },
    room_call_changeWebinarType: function (e) {
      const webinarType = e.data.webinarType || RoomCallApi.webinarType.none;
      if(webinarType === this.getWebinarType()) return;

      this.setWebinarType(webinarType);
      
      if(webinarType == RoomCallApi.webinarType.live && !Room.User.hasSpeakerRole()){
        const me = Room.User.getMe();
        ['camera', 'mic'].forEach(roleType => {
          Room.Call.changeUserDeviceRole(roleType, Object.assign(
              {},
              me,
              {
                roomUserRole: {
                  [roleType]: false,
                }
              }));
        })        
      } else{
        ['camera', 'mic'].forEach(roleType => {
          Room.Call.changeUserDeviceRole(roleType);
        })
      }

      Room.emit(e);
    },
  }

  _CoreEvents = {
    userConnectionStats: function(e) {
      const { roomUser, result } = e.data;

      const {
          instantPacketsLost: instantPacketsLost_s,
          instantPacketsSent: instantPacketsSent_s
      } = result.video.send
      const {
          instantPacketsLost: instantPacketsLost_r,
          instantPacketsReceived: instantPacketsReceived_r
      } = result.video.receive

      const packetLost_s = instantPacketsLost_s / instantPacketsSent_s
      const packetLost_r = instantPacketsLost_r / instantPacketsReceived_r
      const packetLost = Math.max(packetLost_s, packetLost_r)

      const sendStatus = (roomUser, levelObj) => {
          const level = (levelObj && levelObj.level) || 0;
          let isSend;

          if(this.Mixer.isMixing()){
              if(this.isWebinarLive()){
                  // live 일 경우 발표자 영상에 표시해주기 위함
                  roomUser = Room.User.getSpeakerRoomUser();
              }else{
                  // mixing 일 경우 참여자 본인의 상태이므로 참여자들에게 상태 전송
                  roomUser = Room.getRoomData().me;
                  isSend = true;
              }
          }

          if(!roomUser){
              return;
          }

          const now = Date.now();

          // loss 발생
          if(level > 0){
              // 마지막 loss 가 발생한지 5 초 이상 됐다면 카운트 초기화
              if(now - (roomUser.networkStatusLossTime || 0) > 5000){
                  roomUser.networkStatusLossCount = 1;
              }else{
                  // loss 카운트 증가
                  roomUser.networkStatusLossCount = (roomUser.networkStatusLossCount || 0) + 1;
              }

              roomUser.networkStatusLossTime = now;

              // 10 초 이내의 loss 가 세번 미만이면 return;
              if(roomUser.networkStatusLossCount < 5){
                  return;
              }
          } else {
              // level 0 이상이 아니면 false로 변경
              isSend = false;
          }

          // ui event
          levelObj = levelObj || {};
          levelObj.level = level;

          Room.trigger('room_user_changeNetworkStatus', { roomUser, levelObj });

          if(isSend){
              const chk = roomUser.networkStatusLevel !== level
                || (
                  !!level
                  && now - (roomUser.networkStatusLevelSendTime || 0) > 10000
                );
              if(chk && this.MixerSFU.isSFU()){
                  roomUser.networkStatusLevel = level;
                  roomUser.networkStatusLevelSendTime = now;

                  roomUserService.sendNetworkStatus({ roomUser, levelObj });
              }
          }
      };

      if (!isNaN(packetLost) && packetLost > 0.02) {
          const level = Math.min(Math.floor(packetLost / 0.02), 9);
          const packetLostSend = Math.min(Math.floor(packetLost_s / 0.02), 9);
          const packetLostReceive = Math.min(Math.floor(packetLost_r / 0.02), 9);

          sendStatus(roomUser, { level,  packetLostSend,  packetLostReceive })
          return
      }

      sendStatus(roomUser, { level: 0,  packetLostSend: 0,  packetLostReceive: 0 })
    }
  }

  _enterCall(checkFirstEnter) {
    this._enterCall_run = this._enterCall_run || _.debounce((checkFirstEnter) => {
      Room.User.ready(() => {
        const first = checkFirstEnter && !!Room.getRoomData().me.firstEnterUser;
        roomCallService.enterRoomCall({
          first: first === true
        })
      });
    }, 300);
    this._enterCall_run(checkFirstEnter);
  }

  _createWebRTCConnection(roomUser) {
    let roomOptions = Room.getRoomData().roomOptions
    let options = {}

    if (roomOptions.useTurnServer) {
      if (
        roomOptions.turnServers != null &&
        roomOptions.turnServers.length > 0
      ) {
        options.iceServers = options.iceServers.concat(roomOptions.turnServers)
      }
    }

    let conn = new GrmWebRTC(options)
    return conn
  }

  isP2P() {
    let roomCall = Room.getRoomData().roomCall
    return roomCall.callType === 'p2p'
  }

  async getUserDevices() {
    return GrmWebRTC.getUserDevice();
  }

  async changeUserDeviceStatus(deviceType, deviceStatus) {
    let stream = await this.Stream.getCurrentLocalStream()
    if (!stream) {
      console.warn('stream is null')
      return
    }

    let trackEnable = deviceStatus === 'on' || deviceStatus === true
    switch (deviceType) {
      case 'camera':
        stream.getVideoTracks().forEach(t => {
          t.enabled = trackEnable
        })
        break
      case 'mic':
        stream.getAudioTracks().forEach(t => {
          t.enabled = trackEnable
        })
        break
    }
  }

  async changeUserDeviceRole(roleType, roomUser){
    let deviceType = null;
    switch (roleType) {
      case 'mic':
      case 'audio':
      case 'audioinput':
        deviceType = 'audio';
        break;
      case 'camera':
      case 'video':
      case 'videoinput':
        deviceType = 'video';
        break;
    }
    const stream = await this.Stream.createLocalStream({roomUser, [deviceType]:{}})
    Room.trigger('room_core_call_changeUserStream', {stream, deviceType});
  }
  
  async changeUserDevice({deviceType, deviceId, virtualBackgroundType, useNoiseCancel}) {
    if (['audiooutput', 'speaker'].includes(deviceType)) {
      // TODO
      return
    }
    
    let settings = this.Stream.getLocalDeviceSetting()
    if (settings[deviceType]?.deviceId === deviceId
        &&(deviceType === 'video' && settings.video.virtualBackgroundType === virtualBackgroundType)
        &&(deviceType === 'audio' && settings.audio.useNoiseCancel === useNoiseCancel)){
      return
    }

    let config = {}
    config[deviceType] = {
      // virtualBackgroundType, useNoiseCancel
    }
    if(deviceId){
      config[deviceType].deviceId = deviceId;
    }

    const currStream = await this.Stream.getCurrentLocalStream(true);
    let stream;
    switch(deviceType){
      case 'video':
      case 'videoinput':
      case 'videoInput':
        const videoTrack = currStream.getVideoTracks()[0];
        if(videoTrack){
          const cons = videoTrack.GrmTrack.getConstraints();
          Object.assign(cons, config.video);
          config.video = cons;
        }
        stream = await this.Stream.createLocalStream(config)
        const newTrack = stream.getVideoTracks()[0];
        if(newTrack === videoTrack){
          return;
        }
        RoomCall.addUserStreamTrack(
            Room.User.getMe().userId,
            'video',
            newTrack
        );
        break;
      default:
        stream = await this.Stream.createLocalStream(config)
        break;
    }

    // this.requestOfferAll()
    Room.trigger('room_core_call_changeUserStream', {stream, deviceType});
  }

  async activateNoiseCancel(activate) {
    let settings = this.Stream.getLocalDeviceSetting()
    if (!settings['audio'] || settings['audio'].useNoiseCancel === activate) {
      return
    }

    await this.Stream.activateNoiseCancel(activate)
  }

  requestOfferAll(reason) {
    if (this.Mixer.isMixing()) {
      this.Mixer.requestOffer(reason)
    } else {
      Room.getRoomData().roomUserList.forEach(ru => {
        if (Room.User.isMe(ru)) return
        this.requestOffer(ru.userId, reason)
      })
    }
  }
  requestOffer(toUserId, reason) {
    const roomUser = Room.User.getRoomUser(toUserId);
    if(!roomUser) return;
    roomCallService.requestOffer({ toUserId, reason })
  }

  setAudioTrackVolumeEvent({userId, stream, track}) {
    if(!stream && !track){
      return;
    }
    if(!track){
      track = stream && stream.getAudioTracks()[0]
    }
    if(!track || track.kind !== 'audio'){
      return;
    }
    stream = new MediaStream([track]);
    GrmWebRTC.setAudioTrackVolumeEvent3(stream, async (data) => {
      data.userId = userId;
      // track 에서 audio volume 이 발생했는지 flag 처리. 다른 곳에서 오류 체크용으로 사용한다.
      let empty = track._grm_active === undefined || track._grm_active === null;
      if(empty || track._grm_active < 1){
        console.log('# active audio track : active[%s], vol[%d]',
            track._grm_active, data.volume, track);
        if(empty){
          track._grm_active = 0;
        }else{
          track._grm_active = 1;
        }
      }
      await this.setUserVolumeData(data);
    }).then(soundMeter => {
      track._grm_soundMeter = soundMeter;
    })
  }

  async setUserVolumeData({userId, volume, avgVolumeSecond}) {
    let roomUser = Room.User.getRoomUser(userId);
    // if(!roomUser) return;

    const now = Date.now();

    // RoomUserBehavior.parseUserSpeakData({roomUser, volume})
    //     .catch(e => console.error(e));

    // Room.trigger('room_call_userMicVolume', {userId, volume});

    if(volume <= 0){
      return;
    }

    // set volume timer
    let data = this.#timer;
    if(!data._timer_volume){
      data._timer_volume_obj = {};
      data._timer_volume = setInterval(() => {
        const keys = Object.keys(data._timer_volume_obj);
        if(keys.length === 0){
          clearInterval(data._timer_volume);
          delete data._timer_volume;
          delete data._timer_volume_obj;
        }

        const now = Date.now();
        keys.forEach(userId => {
          if(now - data._timer_volume_obj[userId].time > 400){
            // this.setUserVolumeData({userId, volume: 0})
            Room.trigger('room_call_userMicVolume', {userId, volume: 0});
            delete data._timer_volume_obj[userId];
          }else{
            Room.trigger('room_call_userMicVolume', {
              userId,
              volume: data._timer_volume_obj[userId].volume,
              avgVolumeSecond: data._timer_volume_obj[userId].avgVolumeSecond
            });
          }
        });
      }, 200);
    }
    data._timer_volume_obj[userId] = {time: now, volume, avgVolumeSecond};
  }

  // userConnectionStats({userId, start}) {
  //   if(this.isMixing()){
  //     let mixer = this.Mixer.getMixer();
  //     // mixer.conn.
  //     this.Mixer.conectionStats({start});
  //   }else{
  //     //
  //   }
  // }

  getUserStreams (userId) {
    let roomUser = userId === 'me' ? Room.User.getMe() : Room.User.getRoomUser(userId);
    if(!roomUser){
      if(Room.User.isMe(userId)){
        roomUser = Room.User.getMe();
      }else{
        return {};
      }
    }
    if(!roomUser.streams){
      roomUser.streams = {
        video: new MediaStream(),
        audio: new MediaStream(),
        screen: new MediaStream(),
      }
      for(let key in roomUser.streams){
        roomUser.streams[key].userId = roomUser.userId;
      }
      if(Room.User.isMe(roomUser)){
        this.Stream.getCurrentLocalStream(true)
            .then(stream => {
              if(stream.getVideoTracks()[0]){
                roomUser.streams.video.addTrack(stream.getVideoTracks()[0]);
              }
              if(stream.getAudioTracks()[0]){
                roomUser.streams.video.addTrack(stream.getAudioTracks()[0]);
              }
            });

      }
    }
    return roomUser.streams;
  }

  addUserStreamTrack (userId, type, track) {
    if(track._grm_tg){
      let oriTrack = track._grm_tg.getSourceVideoMediaStreamTrack();
      if(oriTrack){
        track = oriTrack;
      }
    }

    const streams = this.getUserStreams(userId);
    const stream = streams[type] = streams[type] || new MediaStream();
    let old = stream.getTracks().find(t => t.kind === track.kind);
    if(old){
      if(old === track) return;
      // TODO old track stop?
      stream.removeTrack(old);
      stream.dispatchEvent(
        new CustomEvent('removetrack', { detail: { old } })
      );
    }
    stream.addTrack(track);
    stream.dispatchEvent(
        new CustomEvent('addtrack', { detail: { track } })
    );
  }

  getUserVideoStream({userId}) {
    const streams = this.getUserStreams(userId);
    return streams.video;
    // return new Promise((resolve, reject) => {
    //   Room.trigger('room_core_call_getUserVideoStream', {
    //     userId, roomUser,
    //     callback: stream => {
    //       resolve(stream);
    //     }
    //   });
    // });
  }

  async getUserSecondStream({userId}) {
    if(Room.User.isMe(userId)){
      return this.Stream.getCurrentOriScreenStream();
    }

    const roomUser = Room.User.getRoomUser(userId);
    if(!roomUser){
      return;
    }

    return new Promise((resolve, reject) => {
      Room.trigger('room_core_call_getUserSecondStream', {
        userId, roomUser,
        callback: stream => {
          resolve(stream);
        }
      });
    });
  }

  resizeMergedStream(options) {
    return this.Stream.resizeMergedStreamRelatively(options);
  }

  moveMergedStream(options) {
    return this.Stream.moveMergedStreamRelatively(options);
  }

  updateMergedScreenStream() {
    return this.Stream.updateMergedScreenStream();
  }
  getStreamMergerMatrix(){
    return this.Stream.getStreamMergerMatrix();
  }

  async changeVideoSenderMaxBitrate(data) {
    await Room.trigger('room_core_call_changeVideoSenderMaxBitrate', data);
  }
  async changeSecondVideoSenderMaxBitrate(data) {
    await Room.trigger('room_core_call_changeSecondVideoSenderMaxBitrate', data);
  }

  async pauseMyVideo (options) {
    const stream = await this.Stream.getCurrentLocalStream(true);
    if(!stream) return;
    const track = stream.getVideoTracks()[0];
    if(!track?._grm_tg){
      // TODO
      return;
    }
    track._grm_tg.pause(options);
  }
  async resumeMyVideo () {
    const stream = await this.Stream.getCurrentLocalStream(true);
    if(!stream) return;
    const track = stream.getVideoTracks()[0];
    if(!track) return;
    track.GrmTrackUtils().getTrackGenerator()?.resume();
  }
}

export const RoomCall = new RoomCallApi()
